/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { connect } from 'react-redux'

import IntegrationCard from 'app/views/containers/Organizations/Integrations/IntegrationCard'

import {
  getLMSIntegrations,
} from 'app/state/modules/integrations'
import settings from 'settings'

import OrganizationLayout from '../components/Layout'

class LMSIntegrations extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.getLMSIntegrations(this.props.match.params.organization_uuid)
  }

  render() {
    const integrations = this.props.lmsIntegrations.filter((i) => i.organization_uuid)
    return (
      <OrganizationLayout
        active="lms_integrations"
        isLoading={this.props.loadingIntegrations}
        {...this.props}
      >
        <div className="uk-flex uk-flex-between uk-flex-row uk-flex-middle">
          <h1>
            LMS Integrations
          </h1>
          <button
            onClick={() => {
              this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/lms-integrations/add`)
            }}
            className="uk-button uk-button-primary"
            type="button"
          >
            Add Integration
          </button>
        </div>
        <div
          className="uk-flex uk-flex-row uk-flex-wrap"
          uk-height-match=".integration-card-description"
        >
          {integrations.length === 0 && (
            <p>You have not setup an LMS.</p>
          )}
          {integrations.map((integration) => (
            <IntegrationCard
              key={`${integration.type_key}-${integration.organization_uuid || ''}`}
              small
              noHover
              imageSrc="/static/images/lms_integrations/exceed.jpeg"
              imageHeight={60}
              style={{
                width: 480,
                marginRight: 40,
              }}
              onClick={() => {
                this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/lms-integrations/${integration.type_key}`)
              }}
              color="#f5f8fa"
              keyName="exceed"
            >
              <div
                className="uk-flex uk-flex-left uk-flex-wrap uk-flex-middle uk-widh-1-1 integration-card-description"
              >
                <h4
                  className="uk-margin-remove"
                >
                  {settings.integrationsLms[integration.type_key]}
                </h4>
                <div className="uk-text-right uk-margin-small-top uk-width-1-1 uk-flex uk-flex-right">
                  {Boolean(integration.organization_uuid) && (
                    <label className="uk-label uk-label-success">
                      ACTIVE
                    </label>
                  )}

                </div>
              </div>
            </IntegrationCard>
          ))}

        </div>
      </OrganizationLayout>
    )
  }
}

const mapStateToProps = ({ hacker, integrations }) => ({
  organizations: hacker.organizationsList,
  organizationsHash: hacker.organizationsHash,
  lmsIntegrations: integrations.lmsIntegrations,
})

export default connect(mapStateToProps, {
  getLMSIntegrations,
})(LMSIntegrations)
